import { render, staticRenderFns } from "./CategoryMaterial.vue?vue&type=template&id=2c919b2d&scoped=true&"
import script from "./CategoryMaterial.vue?vue&type=script&lang=js&"
export * from "./CategoryMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c919b2d",
  null
  
)

export default component.exports